import { configureStore } from "@reduxjs/toolkit";
import { api } from "./api/reviewsApi";

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer, // добавляешь reducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware), // и middleware — обязательно
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
